import React, { Fragment } from "react";
import PropTypes from "prop-types";

import propTypes from "../../../../../constants/propTypes";
import EmptyState from "../../../../ui/EmptyState";

import { GridSection, GridWrapper } from "./components";
import Grid from "./Grid";

const MainSection = ({
  specRequirement,
  onDelete,
  onApprove,
  loaderActive,
  setLoaderActive,
}) => {
  if (specRequirement.files > 0) {
    return (
      <Fragment>
        <GridSection>
          <GridWrapper>
            <Grid
              specRequirement={specRequirement}
              onDelete={onDelete}
              onApprove={onApprove}
              loaderActive={loaderActive}
              setLoaderActive={setLoaderActive}
            />
          </GridWrapper>
        </GridSection>
      </Fragment>
    );
  }
  return (
    <Fragment>
      <GridSection>
        <GridWrapper>
          <EmptyState intent="normal">No files Uploaded</EmptyState>
        </GridWrapper>
      </GridSection>
    </Fragment>
  );
};

MainSection.propTypes = {
  specRequirement: propTypes.specRequirement,
  loaderActive: PropTypes.string,
  onDelete: PropTypes.func,
  onApprove: PropTypes.func,
  setLoaderActive: PropTypes.func,
};

export default MainSection;
